export default "__VITE_ASSET__BsOUp6LA__"